/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// @mui material components
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import Navbar from 'examples/Navbars/NavBar';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

// Component
import RpPurchaseSale from './RpPurchaseSale';
import RpSupplierProduct from './RpSupplierProduct';
import RpPurchase from './RpPurchase';
import RpPurchaseMinMax from './RpPurchaseMinMax';
import RpPurchaseBranch from './RpPurchaseBranch';
import RpPurchaseData from './RpPurchaseData';
import RpStockPurchase from './RpStockPurchase';
import RpQuantityAvg from './RpQuantityAvg';
import RpComparePo from './RpComparePo';
import RpConsignmentSale from './RpConsignmentSale';

function ReportPurchase() {
  const mod = 'report_purchase';
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const app = useSelector((state) => state[APP_STATE]);
  const [menu, setMenu] = useState([]);

  const init = () => {
    FetchData('OPTIONS', `/report/load`, app.token, {
      lang: app.lang,
      code: 'purchase',
    }).then((result) => {
      if (result.status === 'ok') {
        setMenu(result.data);
      } else {
        Func.exitApp();
      }
    });
  };

  const setBtnBadge = (name, link, key) => {
    return (
      <Grid item xs={12} key={key}>
        <MDButton color='light' href={link} fullWidth>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'left',
              width: '100%',
              gap: 1,
              fontSize: 15,
              fontWeight: 400,
            }}
          >
            {key}. {name}
          </Box>
        </MDButton>
      </Grid>
    );
  };

  const renderButton = () => {
    return (
      <MDBox mb={7}>
        <Card sx={{ p: 2 }}>
          <Grid container spacing={1}>
            {menu.map((item, i) =>
              setBtnBadge(t(`menu.${item.code}`), `/${mod}/${item.code}`, i + 1)
            )}
          </Grid>
        </Card>
      </MDBox>
    );
  };

  const renderReport = () => {
    if (id === 'rp_stock_purchase') return <RpStockPurchase />;
    if (id === 'rp_quantity_avg') return <RpQuantityAvg />;
    if (id === 'rp_purchase') return <RpPurchase />;
    if (id === 'rp_purchase_data') return <RpPurchaseData />;
    if (id === 'rp_purchase_sale') return <RpPurchaseSale />;
    if (id === 'rp_purchase_minmax') return <RpPurchaseMinMax />;
    if (id === 'rp_supplier_product') return <RpSupplierProduct />;
    if (id === 'rp_purchase_branch') return <RpPurchaseBranch />;
    if (id === 'rp_compare_po') return <RpComparePo />;
    if (id === 'rp_consignment_sale') return <RpConsignmentSale />;

    return (
      <MDBox>
        <Navbar route={[t(`menu.report`), t(`menu.report_purchase`)]} />
        <MDBox py={3}>{renderButton()}</MDBox>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    if (id === undefined) {
      init();
    }
  }, [id]);

  return (
    <DashboardLayout>
      {renderReport()}
      <Footer />
    </DashboardLayout>
  );
}

export default ReportPurchase;
